import { ComponentType } from 'react';
import { Thing } from 'schema-dts';

import LinkGroupRenderer from '@/components/renderers/link-group';
import MarkdownRenderer from '@/components/renderers/markdown';
import TestimonialGroupRenderer from '@/components/renderers/testimonial-group';

import HowToSpecialtyRenderer from '@/features/specialty-page/hygraph/renderers/how-to-specialty.renderer';
import CardRenderer from '@/hygraph/renderers/card.renderer';
import CardsCarouselRenderer from '@/hygraph/renderers/cards-carousel.renderer';
import ContentSectionRenderer from '@/hygraph/renderers/content-section.renderer';
import ContentSectionWithImageRenderer from '@/hygraph/renderers/content-section-with-image-row.renderer';
import CTARenderer from '@/hygraph/renderers/cta.renderer';
import FaqGroupRenderer from '@/hygraph/renderers/faq-group';
import FaqListingRenderer from '@/hygraph/renderers/faq-list.renderer';
import HeroWithSearchRenderer from '@/hygraph/renderers/hero-with-search.renderer';
import HowToRenderer from '@/hygraph/renderers/how-to.renderer';
import ImageRenderer from '@/hygraph/renderers/image.renderer';
import JobBlocksRenderer from '@/hygraph/renderers/job-blocks.renderer';
import LinkRenderer from '@/hygraph/renderers/link.renderer';
import PressListRenderer from '@/hygraph/renderers/press-list.renderer';
import ProfileRenderer from '@/hygraph/renderers/profile.renderer';
import QuoteCardRenderer from '@/hygraph/renderers/quote-card.renderer';
import RowRenderer from '@/hygraph/renderers/row.renderer';
import SeparatorRenderer from '@/hygraph/renderers/separator.renderer';
import SidebarRenderer from '@/hygraph/renderers/sidebar.renderer';
import SparkLineOverflowRenderer from '@/hygraph/renderers/spark-line-overflow.renderer';
import SparkLineWithIllustrationRenderer from '@/hygraph/renderers/spark-line-with-illustration.renderer';
import SpecialtyCtaRenderer from '@/hygraph/renderers/specialty-cta.renderer';
import StaticComponentRenderer from '@/hygraph/renderers/static-component.renderer';
import StaticSidebarComponentRenderer from '@/hygraph/renderers/static-sidebar-component.renderer';
import StatisticRenderer from '@/hygraph/renderers/statistic.renderer';
import TextRenderer from '@/hygraph/renderers/text.renderer';
import { TSchemaContext, TSchemaData } from '@/services/schema-service';

type RendererData = Record<string, unknown> & { index?: number | undefined };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderers: Record<string, ComponentType<any>> = {
  Profile: ProfileRenderer,
  Card: CardRenderer,
  CardsCarousel: CardsCarouselRenderer,
  ContentSection: ContentSectionRenderer,
  ContentSectionWithImageRow: ContentSectionWithImageRenderer,
  Cta: CTARenderer,
  FaqGroup: FaqGroupRenderer,
  FaqListing: FaqListingRenderer,
  HeroWithSearch: HeroWithSearchRenderer,
  HowTo: HowToRenderer,
  HowToSpecialty: HowToSpecialtyRenderer,
  Image: ImageRenderer,
  JobBlock: JobBlocksRenderer,
  Link: LinkRenderer,
  LinkGroup: LinkGroupRenderer,
  Markdown: MarkdownRenderer,
  PressList: PressListRenderer,
  QuoteCard: QuoteCardRenderer,
  Row: RowRenderer,
  Separator: SeparatorRenderer,
  Sidebar: SidebarRenderer,
  SparkLineOverflow: SparkLineOverflowRenderer,
  SparkLineWithIllustration: SparkLineWithIllustrationRenderer,
  SpecialtyCTA: SpecialtyCtaRenderer,
  StaticComponent: StaticComponentRenderer,
  StaticSidebarComponent: StaticSidebarComponentRenderer,
  Statistic: StatisticRenderer,
  TestimonialGroup: TestimonialGroupRenderer,
  Text: TextRenderer,
};

export function getRenderer(__typename: string | undefined) {
  return __typename && renderers[__typename];
}

export function getSchemaBuilder(__typename: string | undefined) {
  const renderer = getRenderer(__typename);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return renderer?.buildSchema as  // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | ((component: any, context?: TSchemaContext) => TSchemaData<Thing>)
    | undefined;
}

export const getRendererData = (props: RendererData): RendererData => {
  const index = typeof props.index === 'number' ? props.index + 1 : 0;
  return { ...props, index };
};
